import { createSlice } from "@reduxjs/toolkit";
import { verifyMail } from "./verifyMail.action.js";

const initialState = {
	isLoading: false,
	verified: false,
	failed: false,
	message: "",
};

const verifyMailSlicer = createSlice({
	name: "verifyMail",
	initialState: initialState,
	extraReducers: {
		[verifyMail.pending]: (state) => {
			state.isLoading = true;
		},
		[verifyMail.fulfilled]: (state, action) => {
			const { message } = action.payload;
			state.isLoading = false;
			state.verified = true;
			state.message = message;
		},
		[verifyMail.rejected]: (state, action) => {
			const { message } = action.error;
			state.isLoading = false;
			state.verified = false;
			state.failed = true;
			state.message = message;
		},
	},
});

export default verifyMailSlicer.reducer;
